<script lang="ts">
	import { Input } from "flowbite-svelte";
	import { createEventDispatcher } from "svelte";
	import { formatPhoneNumber, normalizePhoneNumber } from "#lib/phonenumber.js";

	interface $$Events {
		input: CustomEvent<string>;
		change: CustomEvent<string>;
		keydown: KeyboardEvent;
		keyup: KeyboardEvent;
		keypress: KeyboardEvent;
		focus: FocusEvent;
		blur: FocusEvent;
	}

	const dispatch = createEventDispatcher();

	export let value = "";
	export let placeholder: string | undefined = undefined;

	function handleInput(e: Event) {
		const str = (e.target as HTMLInputElement).value;
		value = normalizePhoneNumber(str);
		dispatch("input", value);
	}

	function handleChange(e: Event) {
		const str = (e.target as HTMLInputElement).value;
		value = normalizePhoneNumber(str);
		dispatch("change", value);
	}
</script>

<Input type="tel" value={formatPhoneNumber(value ?? "")} {placeholder} {...$$restProps} on:input={handleInput} on:change={handleChange} on:keydown on:keyup on:keypress on:focus on:blur />
